var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12276 1.12276C1.84165 0.403868 2.81667 0 3.83333 0H12.7778C13.1167 0 13.4417 0.134623 13.6813 0.374252L22.6257 9.3187C22.8654 9.55833 23 9.88334 23 10.2222V24.2778C23 25.2944 22.5961 26.2695 21.8772 26.9884C21.1584 27.7072 20.1833 28.1111 19.1667 28.1111H3.83333C2.81667 28.1111 1.84165 27.7072 1.12276 26.9884C0.403868 26.2695 0 25.2944 0 24.2778V3.83333C0 2.81667 0.403868 1.84165 1.12276 1.12276ZM3.83333 2.55556C3.49445 2.55556 3.16944 2.69018 2.92981 2.92981C2.69018 3.16944 2.55556 3.49445 2.55556 3.83333V24.2778C2.55556 24.6167 2.69018 24.9417 2.92981 25.1813C3.16944 25.4209 3.49445 25.5556 3.83333 25.5556H19.1667C19.5056 25.5556 19.8306 25.4209 20.0702 25.1813C20.3098 24.9417 20.4444 24.6167 20.4444 24.2778V10.7515L12.2485 2.55556H3.83333Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7778 0C13.4835 0 14.0556 0.572081 14.0556 1.27778V8.94444H21.7222C22.4279 8.94444 23 9.51653 23 10.2222C23 10.9279 22.4279 11.5 21.7222 11.5H12.7778C12.0721 11.5 11.5 10.9279 11.5 10.2222V1.27778C11.5 0.572081 12.0721 0 12.7778 0Z",
    fill: "#BCAB79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicingIcon);
export default __webpack_public_path__ + "static/media/invoicing-icon.4d2c173511eb08177e96c9b9336d07ce.svg";
export { ForwardRef as ReactComponent };